module.exports = __webpack_public_path__ + "img/agua.73f354b9.svg";